import React from "react";
import { Link } from "react-router-dom";

const SignupHead = () => {
  return (
    <div className="breadcrumbs d-flex align-items-center">
      <div
        className="container position-relative d-flex flex-column align-items-center"
        data-aos="fade"
      >
        <h2>Sign Up</h2>
        <ol>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>Sign Up</li>
        </ol>
      </div>
    </div>
  );
};

export default SignupHead;
